import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  DialogTitle,
  TableHead,
  TableRow,
  TableCell,
  Table,
  Grid,
  TableBody,
  TableContainer,
} from "@mui/material";
import { connect, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "Components/Common/Dialog/DialogComponents";
import TableEmptyState from "Components/Common/Table/TableEmptyState";
// import parse from "html-react-parser";
const useStyle = makeStyles((theme) => ({
  rsAccessMain: {
    display: "flex",
    justifyContent: "flex-start",
    paddingBottom: "10px",
    "&>h5": {
      paddingRight: "5px",
    },
  },
  rsAlignMain: {
    // paddingTop: "20px",
    // paddingBottom: "20px",
  },
  tableBody: {
    "&>tr": {
      "&>td": {
        paddingLeft: "10px",
        paddingRight: "10px",
      },
    },
  },
  tableHead: {
    "&>tr": {
      "&>td": {
        paddingLeft: "10px",
        paddingRight: "10px",
      },
    },
  },
  tableContainer: {
    marginBottom: "20px !important",
    height: "auto !important",
    padding: "0",
  },
}));

const ImportExtraDataDiloag = (props) => {
  const { open, setOpen, extraData } = props;
  const classes = useStyle();
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <PrimaryDialogTitle handleClose={handleClose} title="Extra Data " />
        <DialogContent>
          <Box className={classes.rsAlignMain}>
            <Grid className="common-table">
              <TableContainer className={classes.tableContainer}>
                <Table stickyHeader>
                  <TableHead className={classes.tableHead}>
                    {extraData?.map((item, key) => {
                      let temp = Object.values(item);
                      let tempkey = Object.keys(item);

                      if (key === 0) {
                        return (
                          <TableRow key={key}>
                            {tempkey?.map((value, key) => {
                              return <TableCell key={key}>{value}</TableCell>;
                            })}
                          </TableRow>
                        );
                      }
                    })}
                  </TableHead>
                  {extraData?.map((item, key) => {
                    let temp = Object.values(item);
                    let tempkey = Object.keys(item);
                    return (
                      <>
                        <TableBody className={classes.tableBody}>
                          <TableRow>
                            {temp?.map((value, key) => {
                              return (
                                <TableCell key={key}>
                                  {value === null ? "-" : value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableBody>
                      </>
                    );
                  })}
                  {extraData === null && (
                    <>
                      <TableEmptyState />
                    </>
                  )}
                </Table>
              </TableContainer>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            className="BtnGreen"
            variant="outlined"
            onClick={() => handleClose()}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportExtraDataDiloag);
